import mobile_util from '../mobile/mobile_util'

/*** GA and Comscore ***/
$(window).load(function() {
  if (!slideshare_object || !slideshare_object.slideshow ||
      !slideshare_object.slideshow.is_private) {
    // Load GA and Comscore on all but private presos.
    slideshare_object.loadGAandComscore();
  }
});

$(function() {
  // Foundation init
  if ($(document).foundation) {
    $(document).foundation({
      abide: {
        // Disable validation after each input event
        live_validate: false
      }
    });
  }

  $('body').on('click', '[data-ga-cat]', function() {
    var gaCategory = $(this).data('ga-cat');
    var gaAction = $(this).data('ga-action');
    var gaLabel = $(this).data('ga-label');
    var gaValue = $(this).data('ga-value');
    var gaNonInteractive = $(this).data('ga-noninteractive') || false;

    if (gaCategory && gaAction) {
      slideshare_object.ga(gaCategory, gaAction, gaLabel, gaValue, gaNonInteractive);
    }
  });

  /*** APP init ***/

  slideshare_object.setLanguageSelector();

  slideshare_object.autosuggestTop();

  slideshare_object.lazyloadThumbnails();

  var auth_token = $('meta[name="csrf-token"]').attr('content');

  $.ajaxSetup({
    beforeSend: function(xhr, req) {
      if(req.type === 'GET') {
        return;
      }

      // returns the hostname of a url
      function url_hostname(url) {
        var a = document.createElement('a');

        // converting relative url to absolute url for hostname resolution on IE
        a.href = url;
        var tempUrl = a.href;
        a.href = tempUrl;
        return a.hostname;
      }

      // Add CSRF token to same origin requests
      if (url_hostname(req.url) === window.location.hostname) {
        xhr.setRequestHeader('X-CSRF-Token', auth_token);
      }
    }
  });

  // Mobile search bar

  var toggleSearchBar = function() {
    var $body = $('body');
    var $mobileSearch = $('#main-nav-mobile-search');

    if ($mobileSearch.is(':visible')) {
      $mobileSearch.hide().find('input').blur();
    } else {
      $mobileSearch.slideDown().find('input').focus();
    }
  };

  $('body').on('click', '.j-open-mobile-search', function(e) {
    e.stopPropagation();
    e.preventDefault();
    toggleSearchBar();
  });

  $('#main-nav-mobile-search form').on('submit', function(e) {
    $('#main-nav-mobile-search').addClass("searching");
  });

  // Global body click handler

  $('body').on('click', function(e) {
    // Check if click is outside mobile search
    if ($(e.target).closest("#main-nav-mobile-search").length <= 0) {
      if ($('#main-nav-mobile-search').is(':visible')) {
        e.stopPropagation();
        e.preventDefault();
        toggleSearchBar();
      }
    }

    const homePageShareModal = $('#homepage-modal-share');
    // when share modal is open on homepage clicking anywhere outside the modal should close it
    if (homePageShareModal.is(":visible")) {
      homePageShareModal.hide();
    }
  });

  // Makes sure lazyload is triggered when the page loads

  $(window).load(function(){
    $("html,body, body .wrapper").trigger("scroll");
  });

  $(document).ready(function() {
    // Mobile Promotions
    if (typeof mobile_util === 'undefined') {
      return;
    }

    // Attempt Deeplink on ios8
    // Try deeplinking on ios even in WebViews (The assumption is that deeplinker pages will never be opened
    // in the slideshare ios app webview)
    if (mobile_util.isSupportedIOS() &&
      slideshare_object.slideshow &&
      slideshare_object.slideshow.mobile_app_url) {
      mobile_util.IOSAutoDeepLink(slideshare_object.slideshow.mobile_app_url);
    }

    if (mobile_util.isIOSWebView()) {
      var _gaq = window._gaq || [];
      _gaq.push(['_trackEvent', slideshare_object.rum_pagekey, "ios_inapp_webview", navigator.userAgent]);
    }
  });
});
